import { createSlice } from "@reduxjs/toolkit";
import { truncateToTwoDecimals } from "../../utils/utils";
import { formatPrice } from "../../utils/utils";

import { toasts } from "../../components/common/Toast/Toast";
import { userService } from "../../Services/userServices";
import { startLoading, stopLoading } from "../loading/loadingSlice";
import { isUserLogin, saveUserData } from "../persist/persistSlice";

const initialState = {
  selectedCoinId: null,
  saveSignUp: {},
  user: {
    kyc: "not-verified",
  },
  profileImage: {},
  userTransactions: {},
  spotPrice: {},
  profitPrice: {},
  cryptoPrice: {},
  coinRates: {},
  spotPremiumPrice: {},
  userLedger: {},
  walletBalance: {},
  tokenBalance: 0,
  premiumFee: [],
  buySellOrders: {},
  userP2PTxns: {},
  commonWalletBalance: {},
  walletHistory: [],
  coinList: [],
  coinDecimals: {},
  selectedCard: null,
  cardList: null,
};

export const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    saveSignUpCredential: (state, action) => {
      state.saveSignUp = action.payload;
    },
    setUserKyc: (state, { payload }) => {
      state.user.kyc = payload;
    },
   
    saveProfileImage: (state, action) => {
      state.profileImage = action.payload;
    },
    saveUserTransactions: (state, action) => {
      state.userTransactions = action.payload;
    },
    saveSpotPrice: (state, action) => {
      state.spotPrice = action.payload;
    },
    saveProfitPrice: (state, action) => {
      state.profitPrice = action.payload;
    },
    saveCryptoPrice: (state, action) => {
      state.cryptoPrice = action.payload;
    },
    saveCoinRates: (state, action) => {
      state.coinRates = action.payload;
    },

    setSelectedCoinId: (state, action) => {
      state.selectedCoinId = action.payload;
    },
    saveSpotPremiumPrice: (state, action) => {
      state.spotPremiumPrice = action.payload;
    },
    saveUserLedger: (state, action) => {
      state.userLedger = action.payload;
    },
    saveWalletBalance: (state, action) => {
      state.walletBalance = action.payload;
    },
    saveTokeBalance: (state, action) => {
      state.tokenBalance = action.payload;
    },
    savePremiumFee: (state, action) => {
      state.premiumFee = action.payload;
    },
    saveBuySellOrders: (state, action) => {
      state.buySellOrders = action.payload;
    },
    saveUserBuySellOrders: (state, action) => {
      state.userP2PTxns = action.payload;
    },
    saveCommonWalletBalance: (state, action) => {
      state.commonWalletBalance = action.payload;
    },
    saveWalletHistory: (state, action) => {
      state.walletHistory = action.payload;
    },
    saveCoinList: (state, action) => {
      state.coinList = action.payload;
    },
    saveCoinDecimals: (state, action) => {
      state.coinDecimals = action.payload;
    },

    saveEquityPrice: (state, action) => {
      state.equityPrice = action.payload;
    },
    setSelectedCard: (state, action) => {
      state.selectedCard = action.payload;
    },
    saveCardList: (state, action) => {
      state.cardList = action.payload;
    },

  },
});

//
export const {
  saveSignUpCredential,
  saveEquityPrice,
  setUserKyc,
  saveUserTransactions,
  saveSpotPrice,
  saveProfitPrice,
  saveCryptoPrice,
  saveCoinRates,
  saveUserLedger,
  saveWalletBalance,
  saveTokeBalance,
  savePremiumFee,
  saveSpotPremiumPrice,
  saveBuySellOrders,
  saveUserBuySellOrders,
  saveCommonWalletBalance,
  saveWalletHistory,
  setSelectedCoinId,
  saveCoinList,
  saveCoinDecimals,
  setSelectedCard,
  saveCardList,
} = userSlice.actions;
export default userSlice.reducer;

export const usernameEmailExistAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.checkUserExist(data);
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const generateOTPAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.generateOTP(data);
        toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        resolve(err?.response);
      }
    });
  };
};

export const verifyOTPAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.verifyOTP(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        resolve(err?.response);
        dispatch(stopLoading());
      }
    });
  };
};

export const setPasswordSignUpAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.setPasswordSignup(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};
export const unsubscribeAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.unsubscribe(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const userLoginAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.userLogin(data);
        toasts.success(response.data.message);
        dispatch(isUserLogin(true));
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const forgotEmailAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.forgotEmail(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const forgotEmailVerifyAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.forgotEmailVerify(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const resetPasswordAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.resetPassword(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const getEquityTransactionsAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {        
        const accessToken = getState()?.persist?.accessToken;

        const response = await userService.getEquityTranscations(params, accessToken);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const getUserInfoAction = () => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const accessToken = getState()?.persist?.accessToken;
        const response = await userService.getUserInfo(accessToken);
        dispatch(saveUserData(response.data.data));
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const getUsersInvestmentAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getUsersInvestment(params);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const getAllAssetsAction = () => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getAllAssets();
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const getMarketplaceFeeAction = () => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getMarketplaceFee();
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};
export const getUserProfitAction = () => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getUserProfit();
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const logoutUserAction = () => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.logoutUser();
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const updateUserAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.updateUserInfo(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const deactivateAccountAction = () => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.deactivateAccount();
        toasts.success(response.data.message);
        dispatch(isUserLogin(false));
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const uploadProfileAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.uploadProfile(data);
        toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error("Failed to upload image");
        reject(err);
      }
    });
  };
};

export const getTransactionsAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getUserTransactions(data);
        dispatch(saveUserTransactions(response.data.data));
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};



export const getTransactionDetailsAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.getUserTransactionDetails(data);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const getInvoiceDownloadAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.getInvoiceDownload(data);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};
export const getUserBlncAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.getUserBlncDwnld(data);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const getTransactionDetailsDashboardAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getRecentTransactionsDashboard();
        // toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getDashboardGraphDataAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getDashboardGraphData(params);
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getTokenBalanceAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getTokenBalance(data);
        dispatch(saveTokeBalance(response?.data?.data?.quantity));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getnotificationReadStatusAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getnotificationReadStatus(data);
        dispatch(saveTokeBalance(response?.data?.data?.quantity));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getSpotPriceAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getSpotPrice(data);
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const redeemAssetAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.redeemAsset(data);
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getPortfolioAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getPortfolioBalance(params);
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getPremiumFeeAction = () => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getPremiumFee();
        dispatch(savePremiumFee(response.data.data));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getUserWalletBalanceAction = () => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getUserWalletBalance();
        dispatch(saveWalletBalance(response.data.data));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getUserLedgerListAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.getUserWalletLedgerList(params);
        dispatch(saveUserLedger(response.data.data));
        dispatch(stopLoading());
        resolve(response);
      } catch (err) {
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const addWireFundAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.addWireFund(data);
        toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message || "Something went wrong");
        reject(err);
      }
    });
  };
};

export const getShipstationRatesAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getShipstationRates(data);
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getBuySellOrderListAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getBuySellOrdersList(params);
        dispatch(saveBuySellOrders(response.data.data));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getUserBuySellOrdersAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getUserBuySellOrdersList(params);
        dispatch(saveUserBuySellOrders(response.data.data));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};
export const createBuyOrderAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.createBuyOrder(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const cancelOrderAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.cancelUserOrder(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const matchOrderAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.matchP2POrder(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        reject(err);
        toasts.error(err?.response?.data?.message);
        dispatch(stopLoading());
      }
    });
  };
};

export const getUserOrdersHistoryAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getUserOrdersHistory(params);
        dispatch(saveUserBuySellOrders(response.data.data));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getPtpOrderDetailAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getPtpOrderDetail(params);
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const convertCoinAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.convertCoin(data);
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const convertToStableCoinAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.convertToStableCoin(data);
        toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const getWalletBalanceAction = (data) => {
  //combined wallet balance
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.userWalletBalance(data);
        dispatch(saveCommonWalletBalance(response.data.data));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getWalletHistoryAction = (data) => {
  //combined wallet balance
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.userWalletHistory(data);
        dispatch(saveWalletHistory(response.data.data));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getSellWithUsTokenPricesAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getSellWithUsTokenPrices(data);
        dispatch(saveWalletHistory(response.data.data));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const createSellWithUsP2POrderAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.createSellWithUsP2POrder(params);
        toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const userSellWithUsHistoryAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.userSellWithUsHistory(data);
        dispatch(saveWalletHistory(response.data.data));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};
export const userSellWithUsAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.userSellWithUs(data);
        dispatch(saveWalletHistory(response.data.data));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getCryptoBalanceAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getCryptoBalance(data);
        dispatch(saveWalletHistory(response.data.data));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getShipstationCarriersAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getShipstationCarriers(data);
        dispatch(saveWalletHistory(response.data.data));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getUserAllNotificationAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getUserAllNotification(data);
        dispatch(saveWalletHistory(response.data.data));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getNotificationDataAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        // Making a PUT request using userService (assuming it accepts some data)
        const response = await userService.getNotificationData(data); // Ensure `putNotificationData` exists in your userService
        // Optionally dispatch data to Redux state if needed
        // dispatch(saveNotificationData(response.data.data)); // Uncomment if you want to save the updated notification data
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const deleteNotificationDataAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        // Making a PUT request using userService (assuming it accepts some data)
        const response = await userService.deleteNotificationData(data); // Ensure `putNotificationData` exists in your userService
        // Optionally dispatch data to Redux state if needed
        // dispatch(saveNotificationData(response.data.data)); // Uncomment if you want to save the updated notification data
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const cancelSellWithUsAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.cancelSellWithUs(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};
export const getUserCoinListAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getUserCoinList(params);
        const coinList = response?.data?.data?.coinList;
        const map = {};
        coinList.forEach((coin) => {
          map[coin.coin_symbol] = coin.quantity_decimal ?? 8;
        });
        dispatch(saveCoinList(response?.data?.data?.coinList));
        dispatch(saveCoinDecimals(map));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};
export const getActiveCoinAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getActiveCoin(params);
        const coinList = response?.data?.data?.coinList;
        const map = {};
        coinList.forEach((coin) => {
          map[coin.coin_symbol] = coin.quantity_decimal ?? 8;
        });
        dispatch(saveCoinList(response?.data?.data?.coinList));
        dispatch(saveCoinDecimals(map));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const getDepositHistoryAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getDepositHistory(params);
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};
export const getWithdrawHistoryAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getWithdrawHistory(params);
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const generateAccountAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.generateAccount(data);
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const cancelRequestAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.cancelRequest(data);
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const withdrawRequestAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.withdrawRequest(data);
        toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const generateWithdrawOTPAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.generateWithdrawOTP(params);
        toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const addBankDetailsAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.addBankDetails(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        reject(err);
        toasts.error(err?.response?.data?.message);
        dispatch(stopLoading());
      }
    });
  };
};
export const buyEquityTokensAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.buyEquityTokens(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        reject(err);
        toasts.error(err?.response?.data?.message);
        dispatch(stopLoading());
      }
    });
  };
};

export const editBankDetailsAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.editBankDetails(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        reject(err);
        toasts.error(err?.response?.data?.message);
        dispatch(stopLoading());
      }
    });
  };
};

export const deleteBankDetailsAction = () => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.deleteBankDetails();
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        reject(err);
        toasts.error(err?.response?.data?.message);
        dispatch(stopLoading());
      }
    });
  };
};

export const fetchBankDetailsAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.fetchBankDetails(data);
        toasts.success(response.data.message);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const getBankDetailsAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getBankDetails(data);
        dispatch(saveWalletHistory(response.data.data));
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const verifyWithdrawOTPAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.verifyWithdrawOTP(params);
        toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const getFiatWithdrawListAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.getFiatWithdrawList(data);
        dispatch(saveWalletHistory(response.data.data));
        dispatch(stopLoading());
        resolve(response);
      } catch (err) {
        dispatch(stopLoading());
        reject(err);
      }
    });
  };
};

export const getuserBalanceReportAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.userBalanceReport(data);
        dispatch(saveWalletHistory(response.data.data));
        dispatch(stopLoading());
        resolve(response);
      } catch (err) {
        dispatch(stopLoading());
        reject(err);
      }
    });
  };
};
export const getequityTokenDetailsAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.equityTokenDetails(data);
        dispatch(saveWalletHistory(response.data.data));
        dispatch(stopLoading());
        resolve(response);
      } catch (err) {
        dispatch(stopLoading());
        reject(err);
      }
    });
  };
};

export const getCoinListAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.getCoinList(data);
        dispatch(saveWalletHistory(response.data.data));
        dispatch(stopLoading());
        resolve(response);
      } catch (err) {
        dispatch(stopLoading());
        reject(err);
      }
    });
  };
};
export const getuserTransactionAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.userTransaction(data);
        dispatch(saveWalletHistory(response.data.data));
        dispatch(stopLoading());
        resolve(response);
      } catch (err) {
        dispatch(stopLoading());
        reject(err);
      }
    });
  };
};

export const cancelWithdrawRequestAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.cancelWithdrawRequest(params);
        toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** BANNER ACTION **********
export const getBannerAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getBanner(params);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** DEPOSIT ACTION **********
export const getDepositListAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getDeposit(params);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** WITHDRAW ACTION **********
export const getWithdrawListAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getWithdraw(params);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** PENDING DEPOSIT ACTION **********
export const getPendingDepositsAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getPendingDeposits(params);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** CRYPTO PORTFOLIO VALUE ACTION **********
export const getCryptoPortfolioValueAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getCryptoPortfolioValue(params);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** GET TRANSACTIONS BALANCE ACTION **********
export const getTransactionsBalanceAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getTransactionBalance(params);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** GET TRADING VOLUME ACTION **********
export const getTradingVolumeAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getTradingVolume(params);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** SET PRICE ALERT ACTION **********
export const setPriceAlertAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.setPriceAlert(params);
        resolve(response);
        toasts.success(response.data.message);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** GET PRICE ALERT LIST ACTION **********
export const getPriceAlertsListAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getPriceAlertList(params);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** DELETE PRICE ALERT  ACTION **********
export const deletePriceAlertsAction = (params) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.deletePriceAlert(params);
        resolve(response);
        toasts.success(response.data.message);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const cardDetailsAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.cardDetails(data);
        if (response?.status === 200) {
          dispatch(saveCardList(response?.data?.data || []));
        }
        resolve(response);
        // toasts.success(response.data.message);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const displayPinAction = (data, rainId) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.displayPin(data, rainId);
        resolve(response);
        toasts.success(response.data.message);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const activeCardAction = (data, cardId) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.activeCard(data, cardId);
        resolve(response);
        toasts.success(response.data.message);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const cardTranstionAction = (applicationId, data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.cardTranstion(applicationId, data);
        resolve(response);
        // toasts.success(response.data.message);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};
export const cardDataAction = (applicationId) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.cardData(applicationId);
        resolve(response);
        // toasts.success(response.data.message);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const revealSecretPinAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.revealSecretPin(data);
        resolve(response);
        // toasts.success(response.data.message);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const initiateApplicationAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.initiateApplication(data);
        resolve(response);
        // toasts.success(response.data.message);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const applyRainCardAction = (data, applicationId) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.applyRainCard(data, applicationId);
        resolve(response);
        // toasts.success(response.data.message);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};
export const applyCardApplicationAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.applyCardApplication(data);
        resolve(response);
        // toasts.success(response.data.message);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** SET UPDATE PIN ACTION **********
export const setUpdateAction = (data, rainId) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.setUpdatePin(data, rainId);
        resolve(response);
        toasts.success(response.data.message);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** TOP UP CARD ACTION **********
export const topUpCardAction = (data, rainId) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.topUpCard(data, rainId);
        resolve(response);
        toasts.success(response.data.message);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** OCCUPATION CODES **********
export const getOccupationCodesAction = (data, rainId) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getOccupationCodes(data);
        resolve(response);
        // toasts.success(response.data.message);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** GET CARD CONTROLS ACTION **********
export const getCardControlsAction = (rainId) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getCardControls(rainId);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** UPDATE CARD CONTROLS ACTION **********
export const updateCardControlsAction = (data, rainId) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.updateCardControls(data, rainId);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** GET UNBILLED TRANSCTIONS ACTION **********
export const getUnbiledTransactionsAction = (data, rainId) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getUnbiledTransactions(data, rainId);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** GET CARD STATEMENT ACTION **********
export const getCardStatementAction = (data, rainId) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getCardStatement(data, rainId);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

// ********** REPORT ISSUE ACTION **********
export const reportIssueAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.reportIssue(data);
        resolve(response);
        toasts.success(response.data.message);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const getGlobalCardSettingsAction = (cardType) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getGlobalCardSettings(cardType);
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  };
};

export const updateManagecardAction = (data, cardId) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.updateManageCard(data, cardId);
        toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const getViewCardAction = (rainId, data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getViewCard(rainId, data);
        toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const getPaymentOptionsAction = () => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getPayment();
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const submitPaymentAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.submitPayment(data);
        toasts.success(response.data.message);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const viewStatementAction = (rainId, data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.viewStatement(rainId, data);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const getPaymentTransactionsAction = (rainId, data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await userService.getPaymentTransactions(rainId, data);
        resolve(response);
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
      }
    });
  };
};

export const getCryptoByFilterAction = (data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.getCryptoByFilter(data);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};

export const cancelCardAction = (rainId, data) => {
  return async (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch(startLoading());
        const response = await userService.cancelCard(rainId, data);
        resolve(response);
        dispatch(stopLoading());
      } catch (err) {
        toasts.error(err?.response?.data?.message);
        reject(err);
        dispatch(stopLoading());
      }
    });
  };
};


